import { put, takeEvery, takeLatest } from 'redux-saga/effects';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import locationServices from './services';
import locationActions from './actions';
import locationTypes from './types';

function* getLocationsListRequest(action) {
	try {
		let response = yield sagaCallService(
			locationServices.getLocationsList,
			action,
			action.payload
		);
		yield put(locationActions.locationsListSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, locationActions.locationsListFailure);
	}
}

function* getNeshanPositionRequest(action) {
	try {
		let response = yield sagaCallService(
			locationServices.getNeshanPosition,
			action,
			action.payload
		);
		yield put(locationActions.neshanPositionSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, locationActions.neshanPositionFailure);
	}
}

function* pointToLocationRequest(action) {
	try {
		let response = yield sagaCallService(
			locationServices.pointToLocation,
			action,
			action.payload
		);
		yield put(locationActions.pointToLocationSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			locationActions.pointToLocationFailure
		);
	}
}
function* pointToAddressRequest(action) {
	try {
		let response = yield sagaCallService(
			locationServices.pointToAddress,
			action,
			action.payload
		);
		yield put(locationActions.pointToAddressSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, locationActions.pointToAddressFailure);
	}
}

function* locationGeneralRequest(action) {
	try {
		const response = yield sagaCallService(
			locationServices.locationGeneral,
			action,
			action.payload
		);

		const typeLocation = action?.payload?.['filters[type_location]'];

		switch (typeLocation) {
			case 5:
				yield put({
					type: locationTypes.LOCATION_PROVINCE.SUCCESS,
					payload: response?.data,
				});
				break;
			case 2:
				yield put({
					type: locationTypes.LOCATION_CITY.SUCCESS,
					payload: response?.data,
				});
				break;
			case 3:
				yield put({
					type: locationTypes.LOCATION_AREA.SUCCESS,
					payload: response?.data,
				});
				break;
			case 4:
				yield put({
					type: locationTypes.LOCATION_DISTRICT.SUCCESS,
					payload: response?.data,
				});
				break;
			default:
				console.warn(`Unhandled type_location: ${typeLocation}`);
				break;
		}
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			locationActions.locationGeneralFailure
		);
	}
}

const locationSagas = [
	takeEvery(locationTypes.LIST.REQUEST, getLocationsListRequest),
	takeEvery(locationTypes.NESHAN_POSITION.REQUEST, getNeshanPositionRequest),
	takeEvery(locationTypes.POINT_TO_ADDRESS.REQUEST, pointToAddressRequest),
	takeEvery(locationTypes.POINT_TO_LOCATION.REQUEST, pointToLocationRequest),
	takeEvery(locationTypes.LOCATION_GENERAL.REQUEST, locationGeneralRequest),
];

export default locationSagas;
